/**
 * Grid Layout Constants
 * 
 * Defines the structure and dimensions of the lead sheet grid system.
 * The grid displays musical regions across bars in a paginated format.
 */

/**
 * Number of bars (columns) displayed per line
 * Standard music notation typically uses 8 bars per line
 */
export const BARS_PER_LINE = 8;

/**
 * Number of lines displayed per page
 */
export const LINES_PER_PAGE = 6;

/**
 * Total number of bar positions per page
 * Calculation: BARS_PER_LINE × LINES_PER_PAGE
 */
export const BARS_PER_PAGE = BARS_PER_LINE * LINES_PER_PAGE;

/**
 * Minimum bar length to display region in full view
 * Regions shorter than this show a simplified "short" view
 */
export const MIN_BARS_FOR_FULL_DISPLAY = 2;

/**
 * Grid column structure for CSS Grid
 * Format: 1fr (padding) + 8×2fr (bars) + 1fr (padding)
 */
export const GRID_TEMPLATE_COLUMNS = '1fr repeat(8, 2fr) 1fr';

/**
 * Gap between grid rows in pixels
 */
export const ROW_GAP = 10;


